/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GetStatusResponse model module.
 * @module model/GetStatusResponse
 * @version 2.8.0
 */
class GetStatusResponse {
    /**
     * Constructs a new <code>GetStatusResponse</code>.
     * @alias module:model/GetStatusResponse
     * @param name {String} 
     * @param version {String} 
     * @param status {String} 
     */
    constructor(name, version, status) { 
        
        GetStatusResponse.initialize(this, name, version, status);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, version, status) { 
        obj['name'] = name;
        obj['version'] = version;
        obj['status'] = status;
    }

    /**
     * Constructs a <code>GetStatusResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetStatusResponse} obj Optional instance to populate.
     * @return {module:model/GetStatusResponse} The populated <code>GetStatusResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetStatusResponse();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('components')) {
                obj['components'] = ApiClient.convertToType(data['components'], [Object]);
            }
        }
        return obj;
    }


}

/**
 * @member {String} name
 */
GetStatusResponse.prototype['name'] = undefined;

/**
 * @member {String} version
 */
GetStatusResponse.prototype['version'] = undefined;

/**
 * @member {String} status
 */
GetStatusResponse.prototype['status'] = undefined;

/**
 * @member {Array.<Object>} components
 */
GetStatusResponse.prototype['components'] = undefined;






export default GetStatusResponse;

